<template>
    <div class="enterAmount frameMobile">
        <h3>{{'components/payment/amount.enter-amount' | trans}}</h3>

        <div class="amountBoxes">
            <div v-if="parseFloat(outstandingBillAmountValue)"
                 class="box" @click="activate('instalment')" :class="{ active : active === 'instalment' }">
                <div v-if="$mq=='sm'" class="inputCheckboxWrap">
                    <input v-model="amountType" id="instalment" type="radio" name="amount" value="instalment">
                    <label class="radio" for="instalment"></label>
                </div>
                <h4>{{'components/payment/amount.settle-outstanding-bills' | trans}}</h4>
                <span class="block desc">{{'components/payment/amount.pay-the-amount-currently-due' | trans}}</span>
                <span class="block price">{{(typeof user.instalment.symbol !== 'undefined') ? user.instalment.symbol : ''}}{{outstandingBillAmountValue}}</span>
            </div>
            <div
				 class="box customAmount" @click="activate('custom')" :class="{ active : active === 'custom' }">
                <div v-if="$mq=='sm'" class="inputCheckboxWrap">
                    <input v-model="amountType" id="custom" type="radio" name="amount" value="custom">
                    <label class="radio" for="custom"></label>
                </div>

                <h4>{{'components/payment/amount.pay-what-you-want' | trans}}</h4>
                <span class="block desc">{{'components/payment/amount.using-this-option-will-make-an-early-payment-on-your-account' | trans}}.</span>
                <div class="inputShortWrap">
                    <input v-model.number="customValue" type="text" :placeholder="'0.00'">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

	export default {
        props: {
            amountType: {
                type: String
            },
            customAmountValue: {
                type: Number
            },
            instalmentAmountValue: {
                type: Number,
                default: 0
            },
            outstandingBillAmountValue: {
                type: Number,
                default: 0
            },
            fullAmountValue: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                active: this.amountType,
                customValue: ''
            }
        },
        methods: {
            activate: function (el) {
                this.active = el;
                this.$emit('setAmountType', this.active);
            }
        },
        watch: {
            customValue: function (val) {
                if (this.fullAmountValue < this.customValue) {
                    this.customValue = this.fullAmountValue;
                }
                this.$emit('setCustomAmountValue', this.customValue);
            },

        },
		mounted() {},
		computed: {
			...mapState(['user'])
		}
    }
</script>
